import * as React from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import defaultTheme from './themes/defaultTheme';
import darkTheme from './themes/darkTheme';
import './App.css';
import Routes from './components/Routes'

import { ConfigProvider } from './contexts/Config';
import { AuthProvider } from 'contexts/Auth';
import { DataProvider } from 'contexts/Data';

// The following function suppresses specific console messages that are not relevant to the user experience.
// Please justify any changes to this list with a comment explaining why the message is being suppressed.
const suppressSpecificConsoleMessages = () => {
  const originalWarn = console.warn;
  const originalError = console.error;

  const suppressedMessages = [
    'useResizeContainer - The parent DOM element of the Data Grid has an empty', //MUI Data Grid component when it is inside a hidden tab
  ];

  console.warn = (...args) => {
    const message = args[0];
    if (
      typeof message === 'string' &&
      suppressedMessages.some((m) => message.includes(m))
    ) {
      return;
    }
    originalWarn(...args);
  };

  console.error = (...args) => {
    const message = args[0];
    if (
      typeof message === 'string' &&
      suppressedMessages.some((m) => message.includes(m))
    ) {
      return;
    }
    originalError(...args);
  };
};
suppressSpecificConsoleMessages();


export default function App() {
  const useStyledEngine = true;
  return (
    <>
      <ConfigProvider>
        <AuthProvider>
          <DataProvider>
            {
              useStyledEngine ? (
                <StyledEngineProvider injectFirst>
                  <StyledApp />
                </StyledEngineProvider>
              ) : (
                <StyledApp />
              )
            }
          </DataProvider>
        </AuthProvider>
      </ConfigProvider>
      </>
      );
}

      function StyledApp() {
  const currentTheme = localStorage.getItem('theme') === 'dark' ? darkTheme : defaultTheme;
      return (
      <ThemeProvider theme={currentTheme}>
        <CssBaseline />
        <div className="App">
          <Routes />
        </div>
      </ThemeProvider>
      );
}
